<div class="error-page">
  <img src="/assets/404.png" alt="">
</div>
